<template>
  <div class="home">
    <herohoney
      question="Magst du"
      question1="Süßes"
      question2="Regionales"
      question3="die Wilde Pracht"
      claim="Prima! Dann gefällt dir bestimmt auch unser Honig aus der Blühsaison 2021."
      solution="Das Besondere: Ein Imkerpaar aus der Nachbarschaft hat auf einer unserer Flächen einige Bienenstöcke aufgestellt. Und die Bienen haben das Festmahl aus dem Blütenmeer vor ihrer Haustür reichlich genutzt. So ist echter Sommertrachthonig nach den Qualitätskriterien des Deutschen Imkerbundes e.V. entstanden. Und den wollen wir mit euch als Paten teilen."
    />
    <textblockHoney
      headline="Honig direkt von der Blühwiese!"
      column1="Du hast schon eine Blühpatenschaft von der Wilden Pracht verschenkt? Oder selbst eine und verfolgst seit vielen Wochen mit unserer Bienenpost, was auf dem Feld so los ist? Dann haben wir heute eine riesige Überraschung für dich! Denn ein Geheimnis haben wir trotz regelmäßiger Neuigkeiten vom Acker stets gut gehütet: Zusammen mit einem Imkerpaar haben wir „Echten Deutschen Honig“ produziert."
      column2="Mario und Inken haben dafür den Sommer über ein paar Bienenstöcke auf einer der Wilde-Pracht-Blühwiesen aufgestellt. Was wir währenddessen alles Spannendes über die Imkerei gelernt haben, erzählen wir dir natürlich wie immer in der Bienenpost. Nur eines schon vorweg: Das hier ist nicht irgendein Honig, sondern „Echter Deutscher Honig“, der einem bundesweit einheitlichen Standard des Deutschen Imkerbundes e.V. unterliegt und strenge Qualitätsmerkmale erfüllen muss. Das ist übrigens auch der Grund, warum wir weder „Wilde Pracht-Honig“ auf das Etikett schreiben dürfen, noch unser Logo darauf drucken dürfen."
    />
    <cta
      title="Verschenke jetzt Honig aus der Blühsaison 2021."
      subtitle="Oder genieße ihn einfach selber."
    />
    <OrderformHonig />
  </div>
</template>

<script type="text/babel">
// @ is an alias to /src
import Herohoney from "@/components/Herohoney.vue";
import TextblockHoney from "@/components/TextblockHoney.vue";
import Cta from "@/components/Cta.vue";
import OrderformHonig from "@/components/OrderformHonig/OrderformHonig.vue";

export default {
  name: "Home",
  components: {
    Herohoney,
    TextblockHoney,
    Cta,
    OrderformHonig
  },
  metaInfo: {
    title: "Magst du Honig? | Wilde Pracht",
    meta: [
      {
        name: "description",
        content:
          "Die Bienen haben in der Blühsaison 2021 fleißig Honig auf der Blühwiese produziert. Verschenke jetzt Echten Deutschen Imkerhonig von der Wilden Pracht"
      },
      { itemprop: "name", content: "Magst du Honig? | Wilde Pracht" },
      { property: "og:title", content: "Magst du Honig? | Wilde Pracht" },
      {
        itemprop: "description",
        content:
          "Die Bienen haben in der Blühsaison 2021 fleißig Honig auf der Blühwiese produziert. Verschenke jetzt Echten Deutschen Imkerhonig von der Wilden Pracht"
      },
      {
        property: "og:description",
        content:
          "Die Bienen haben in der Blühsaison 2021 fleißig Honig auf der Blühwiese produziert. Verschenke jetzt Echten Deutschen Imkerhonig von der Wilden Pracht"
      }
    ]
  }
};
</script>

<style lang="scss"></style>
